<!--
  侧边菜单
 -->

<template>
  <ul class="side-menu levela" :class="{fixed: getSidemenuStatus}">
    <li class="item index">
      <router-link to="/" class="title">
        <span class="icon icon-menu-logo"></span>
        <span class="name">首页</span>
      </router-link>
    </li>
    <!-- 一级菜单 -->
    <li class="item" v-for="(levelA, index) in menu">
      <a class="title" :id="'menu-' + levelA.id" :class="{'child': levelA.child, active: clickIndex === index}" @click.prevent="enter(levelA, index)">
        <span class="icon" :class="levelA.icon"></span>
        <span class="name">{{levelA.name}}</span>
      </a>
      <!-- 二级菜单 -->
      <div class="scroll-box" :id="'scroll' + index" :style="maxHeight" v-if="levelA.child" v-show="clickIndex === index">
        <ul class="levelb">
          <li class="item" v-for="(levelB, indexB) in levelA.child" @mouseover="clearTime(indexB)" @mouseout="moveOut">
            <a class="title" :id="'menu-' + levelB.id" :class="{'child': levelB.child, active: hoverIndex === indexB, 'router-active': levelB.url === currentIndex || selectLevelB(levelB.child)}" @click.prevent="enter(levelB, index)">
              <span class="icon" :class="levelB.icon"></span>
              <span class="name">{{levelB.name}}</span>
              <div class="bind-event" @mouseover.self="moveOn($event, levelB.child)"></div>
            </a>
            <!-- 三级菜单 -->
            <div class="transition" :style="fixedStyle">
              <ul class="levelc" v-if="levelA.child" v-show="hoverIndex === indexB">
                <li class="item" v-for="levelC in levelB.child">
                  <a class="title" @click.prevent="enter(levelC, index)" :class="{'router-active': levelC.url === currentIndex}">
                    <!-- <span class="icon" :class="levelC.icon"></span> -->
                    <span class="name">{{levelC.name}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </li>

    <li class="switch" :class="{fixed: getSidemenuStatus}" @click="handleSwitch">
      <a href="javascript:;" title="固定左侧菜单栏"><i class="web-icon-stick"></i></a>
    </li>
  </ul>
</template>

<script>
import * as api from 'src/api'
import { LS } from 'assets/js/storage'
import scrollBar from 'src/plugins/scrollbar'
import { mapGetters, mapActions } from 'vuex'

let timer
let itemH = 40

export default {
  created () {
    const url = '/user/getPermissionsMenu.html'
    api.post(url, {}, (data) => {
      this.menu = data.result
      this.currentMenu()
      // 获取详情页权限配置
      this.setDetailConfig(data.detailModuleStatus)
      //  获取用户的呼叫中心的方法
      this.getCallCenterMsg()

      // 设置特殊枚举类
      this.setSpecialEnmus(data.otherProject)

      // 导出的骚操作，偷偷访问一次接口，获取正确的cookie信息
      const url = data.otherProject.export
      const params = {
        first: true
      }
      api.post(url, params, (data) => {})
    })
    if (LS.get('VUE-sidemenu-status') === 'true') {
      this.setSidemenuStatus()
    }
  },
  data () {
    return {
      // 默认展开的菜单序号
      clickIndex: 0,
      hoverIndex: '',
      menu: [],
      currentIndex: '',
      fixedStyle: '',
      maxHeight: ''
    }
  },
  computed: {
    ...mapGetters([
      'getSidemenuStatus'
    ])
  },
  methods: {
    ...mapActions([
      'setDetailConfig',
      'setSidemenuStatus',
      'setSpecialEnmus'
    ]),
    //  获取侧边栏用户的呼叫中心的方法
    getCallCenterMsg () {
      const callcenterurl = '/callcenter/menu/show.do'
      const moduleType = LS.get('VUE-CTI-moduleType')
      api.post(callcenterurl, { moduleType }, (data) => {
        if (data.result.length !== 0) {
          let resultArr = data.result
          //  初始化要插入到menu的对象
          let callcenterMsg = {}
          callcenterMsg.id = moduleType
          callcenterMsg.icon = 'web-icon-call'
          callcenterMsg.name = '呼叫中心'
          callcenterMsg.child = []

          resultArr.forEach((item, index) => {
            //  用户坐席管理
            if (item.indexOf('agentSet') > -1) {
              let agentSetObj = {
                parentId: moduleType,
                icon: 'icon-agent',
                name: '坐席管理',
                isJXC: 1,
                url: '/callCenter/agent'
              }
              callcenterMsg.child.push(agentSetObj)
            } else if (item.indexOf('callLog') > -1) {     //  通话记录
              let callLogObj = {
                parentId: moduleType,
                icon: 'icon-call-log',
                name: '通话记录',
                isJXC: 1,
                url: '/callCenter/callLog'
              }
              callcenterMsg.child.push(callLogObj)
            } else if (item.indexOf('managementCenter') > -1) {    //  管理中心
              let managementCenterObj = {
                parentId: moduleType,
                icon: 'icon-set2',
                name: '管理中心',
                isJXC: 1,
                url: '/callCenter/setting'
              }
              callcenterMsg.child.push(managementCenterObj)
            }
          })
          this.menu.push(callcenterMsg)
        } else {
          return
        }
      })

    },
    // 鼠标点击菜单
    enter (item, index) {
      if (item.child) {
        // 只对一级目录生效
        if (!item.parentId) {
          if (this.clickIndex === index) {
            this.clickIndex = ''
          } else {
            this.clickIndex = index
            // 触发滚动条
            this.addScroll(index)
          }
        }
      } else {
        if (item.isJXC) {
          this.currentIndex = item.url
          let url = item.url.replace('/jxc.htm#', '')
          url !== this.$route.path && this.$router.push(url)
        } else {
          window.location.href = item.url
        }
      }
    },
    // 页面初始化时，展开并选中当前菜单
    currentMenu () {
      const name = window.location.pathname + window.location.hash
      this.menu.forEach((parent, index) => {
        if (parent.child) {
          parent.child.forEach(item => {
            if (item.child) {
              item.child.forEach(item2 => {
                if (item2.url === name) {
                  this.currentIndex = item2.url
                  this.clickIndex = index
                  return
                }
              })
            } else {
              if (item.url === name) {
                this.currentIndex = item.url
                this.clickIndex = index
                return
              }
            }
          })
        }
      })

      // 添加滚动条
      this.$nextTick(() => {
        this.addScroll(this.clickIndex)
      })
    },
    clearTime (index) {
      clearTimeout(timer)
      this.hoverIndex = index
    },
    // 鼠标移上显示子菜单
    moveOn (event, children) {
      const Height = window.innerHeight
      const position = event.target.getBoundingClientRect()
      if (position && children && children.length) {
        const result = (Height - position.top) > children.length * itemH
        if (result) {
          this.fixedStyle = {
            top: `${position.top}px`
          }
        } else {
          this.fixedStyle = {
            top: 'auto',
            bottom: `${Height - position.top - itemH}px`
          }
        }
      }
    },
    // 鼠标移开
    moveOut () {
      const that = this
      timer = setTimeout(function () {
        that.hoverIndex = ''
      }, 50)
    },
    // 增加滚动条
    addScroll (index) {
      const Height = window.innerHeight - 50
      // 设置scroll-box的最大高度
      const itemHeight = Height - (this.menu.length + 2) * itemH
      this.maxHeight = {
        'max-height': itemHeight + 'px'
      }

      const elArr = document.getElementsByClassName('customBar')
      for (let i = 0; i < elArr.length; i++) {
        this.removeElement(elArr[i])
      }
      const e = document.getElementById('scroll' + index)
      this.$nextTick(() => {
        scrollBar(e, 2, 'customBar')
      })
    },
    // 删除node节点
    removeElement (el) {
      let pEl = el.parentNode
      if (pEl) {
        pEl.removeChild(el)
      }
    },

    // 检查是否选中了子菜单
    selectLevelB (children) {
      let result = false
      if (children) {
        children.forEach(child => {
          if (child.url === this.currentIndex) {
            result = true
            return
          }
        })
      }
      return result
    },

    // 展开or收起侧边菜单
    handleSwitch () {
      this.setSidemenuStatus()

      // 存入到localStorage中
      this.$nextTick(() => {
        LS.set('VUE-sidemenu-status', this.getSidemenuStatus)
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .side-menu {
    position: absolute;
    top: 40px;
    left: 0;
    bottom: 0;
    width: 50px;
    background-color: @bg-light;
    z-index: 200;
    transition: width 0.3s;
    &:hover, &.fixed {
      width: 150px;
      .item {
        .title .name {
          width: 84px;
        }
        .levelb .transition {
          left: 150px;
        }
      }
    }
    .item {
      position: relative;
      box-sizing: border-box;
      line-height: 40px;
      &.index {
        .title, .title:hover {
          background-color: @bg-orange;
          border-bottom-color: @bg-orange;
          color: rgb(255, 255, 255);
        }
      }
      .title {
        position: relative;
        display: block;
        color: rgba(255, 255, 255, 0.8);
        border-bottom: 1px solid #223147;
        border-left: 2px solid transparent;
        background-color: @bg-light;
        &:hover {
          border-left-color: @bg-orange;
          color: rgb(255, 255, 255);
        }
        &.active {
          border-left-color: @bg-orange;
        }
        &.child:after {
          position: absolute;
          margin-top: -5px;
          font-size: 12px;
          width: 22px;
          height: 6px;
          line-height: 1;
          right: 0;
          top: 50%;
          text-align: center;
          font-family: 'web-iconfont';
          content: '\e67e'
        }
        .icon {
          display: inline-block;
          vertical-align: middle;
          width: 40px;
          text-align: center;
          font-size: 18px;
          transition: height 0.3s;
        }
        .name {
          display: inline-block;
          vertical-align: top;
          transition: all 0.3s;
          white-space: nowrap;
          overflow: hidden;
          width: 0;
          font-size: 14px;
        }
      }
      .scroll-box {
        display: block;
      }
      .levelb {
        .title {
          background-color: @bg-dark;
          .name {
            font-size: 12px;
          }
          .icon {
            font-size: 15px;
          }
          &.child:after {
            content: '\e67d';
          }
        }
        .router-active {
          border-left-color: @bg-orange;
          color: rgb(255, 255, 255);
        }
        .transition {
          transition: left 0.3s;
          position: fixed;
          left: 50px;
          width: 0;
          z-index: 1001;
          .levelc {
            width: 120px;
            background-color: @bg-light;
            border-left: 1px solid @bg-light;
            .title {
              padding-left: 20px;
            }
          }
        }
      }
      .bind-event {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
        z-index: 200;
      }
    }
    .switch {
      position: absolute;
      left: 14px;
      bottom: 10px;
      transition: all 0.4s;
      i {
        opacity: 0.6;
        color: #fff;
        cursor: pointer;
        border-radius: 10px;
        font-size: 20px;
        border-radius: 50%;
        transition: all 0.6s;
      }
      &:hover {
        i {
          opacity: 1;
        }
      }
      &.fixed {
        left: 110px;
        transform: rotate(405deg);
        i {
          opacity: 1;
        }
      }
    }
  }
</style>
<style lang="less">

  .side-menu:not(.fixed) {
    .customBar {
      left: 48px;
      background-color: rgba(255, 255, 255, 0.2);
      transition: left 0.3s;
      div {
        background-color: rgba(255, 255, 255, 0.4);
      }
    }
    &:hover {
      .customBar {
        left: 148px;
      }
    }
  }
  .side-menu.fixed+div {
    margin-left: 100px;
  }
</style>



// WEBPACK FOOTER //
// side-menu.vue?2b2e5d26